import { ArrowDownLightIcon, ArrowUpLightIcon } from '@global-engineering-shared/gweb-global-icons';
import { Box, Typography } from '@global-engineering-shared/gweb-material-ui';
import ListSubheader from '@material-ui/core/ListSubheader';
import classNames from 'classnames';

import useClasses from 'components/Table/components/TableHeader/TableHeader.styles';
import { ITableHeader, OrderingDirection } from 'components/Table/types/Table';
import { useListScroll } from 'hooks/useListScroll';

const TableHeader = ({
  sorting,
  setSortingConditions,
  idSuffix,
  tableItemGridTemplate,
  columns,
}: ITableHeader) => {
  const { isListScrolled } = useListScroll(`list-header-${idSuffix}`);
  const classes = useClasses({ isListScrolled, tableItemGridTemplate });

  const showAscendingIcon = (columnSortingId: string | undefined) => {
    return (
      !sorting || sorting.field !== columnSortingId || sorting?.direction === OrderingDirection.Asc
    );
  };

  const getSortingIcon = (columnSortingId: string | undefined, id: string) => {
    return showAscendingIcon(columnSortingId) ? (
      <ArrowUpLightIcon fontSize="small" titleAccess={`${id}-asc`} />
    ) : (
      <ArrowDownLightIcon fontSize="small" titleAccess={`${id}-desc`} />
    );
  };

  return (
    <ListSubheader component="div" className={classes.listHeader} id={`list-header-${idSuffix}`}>
      {columns.map(({ label, value, columnSortingId, styles }) => (
        <Box
          key={value}
          style={styles}
          className={classNames([
            classes.headerItem,
            {
              [classes.sortable]: columnSortingId,
              [classes.active]: columnSortingId && sorting?.field === columnSortingId,
            },
          ])}
          onClick={() =>
            columnSortingId && setSortingConditions && setSortingConditions(columnSortingId)
          }
        >
          <Typography variant="caption">{label.toUpperCase()}</Typography>
          {columnSortingId && getSortingIcon(columnSortingId, value)}
        </Box>
      ))}
    </ListSubheader>
  );
};

export default TableHeader;
